export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12040.1a22db36.jpg";